import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { SmoothScroll } from "./components/site/SmoothScroll";
import { Nav } from "./components/site/Nav";
import { Footer } from "./components/site/Footer";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import Quote from "./pages/Quote";
import Careers from "./pages/Careers";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminEmployee from "./pages/AdminEmployee";
import EmployeePortal from "./pages/EmployeePortal";
import PayslipView from "./pages/PayslipView";

const SiteLayout = () => (
  <>
    <Nav />
    <Outlet />
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services/:slug" element={<ServicePage />} />
              <Route path="/quote" element={<Quote />} />
              <Route path="/careers" element={<Careers />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/employees/:id" element={<AdminEmployee />} />
            <Route path="/employee/login" element={<AdminLogin mode="employee" />} />
            <Route path="/employee" element={<EmployeePortal />} />
            <Route path="/payslips/:id" element={<PayslipView />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster theme="dark" position="bottom-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
